import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import {
  downloadExercisePrescriptionPDF,
  downloadPrescriptionPDFByPrescriptionID,
  viewExercisePrescriptionPDF,
  viewPrescriptionPDFByPrescriptionID,
} from "../../services/api_services/AppointmentServices";
import { downloadFileFromURL } from "../../utils/HelperFunctions";
import {
  downloadInvoicePDFByInvoiceID,
  downloadPaymentReceiptPDFByPaymentID,
  downloadRefundReceiptPDFByRefundID,
  viewInvoicePDFByInvoiceID,
  viewPaymentReceiptPDFByPaymentID,
  viewRefundReceiptPDFByRefundID,
} from "../../services/api_services/PaymentService";
import {
  downloadClientConsentFormPDFById,
  downloadConsentFormPDF,
  viewClientConsentFormPDFByID,
  viewConsentFormPDF,
} from "../../services/api_services/ClientServices";
import {
  downloadCasePaperPDF,
  downloadCombinedCasePaperPDF,
  viewCasePaperByCasePaperId,
} from "../../services/api_services/CasePaperServices";
import {
  downloadCertificatePDF,
  downloadCertificateTemplatePDF,
  viewCertificatePDF,
  viewCertificateTemplatePDF,
} from "../../services/api_services/certificateServices";

export default function SelectInstructionModal(props) {
  const [selectedImageSize, setSelectedImageSize] = useState("small");
  const [includeHeaderFooter, setIncludeHeaderFooter] = useState(false);
  const [includeInstructions, setIncludeInstructions] = useState(false);
  const [isDownloadAPILoading, setIsDownloadAPILoading] = useState(false);
  const [isViewAPILoading, setIsViewAPILoading] = useState(false);
  const [invoice, setInvoice] = useState();
  const [payment, setPayment] = useState();

  useEffect(() => {
    if (props.invoiceToDownload) {
      setInvoice(props.invoiceToDownload);
    }

    if (props.paymentToDownload) {
      setPayment(props.paymentToDownload);
    }
  }, [props.invoiceToDownload, props.paymentToDownload]);

  async function handleDocumentAction({
    actionType,
    apiFunction,
    id,
    fileName,
    finalExerciseListToPrint,
    categoryId,
    category,
    organizationId,
    clientId,
    isCombined = false,
  }) {
    const layoutInstructionsDto = {
      includeHeaderFooter,
      includeInstructions,
      imageSize: selectedImageSize,
    };

    setIsDownloadAPILoading(actionType === "download");
    setIsViewAPILoading(actionType === "view");

    let response;

    if (isCombined) {
      const payload = {
        casePaperIds: id,
        clientId,
        layoutInstructionsDto,
      };

      response = await apiFunction({
        payload,
        category,
        organizationId,
      });
    } else {
      const data = JSON.stringify(layoutInstructionsDto);

      response = await apiFunction(
        finalExerciseListToPrint ? finalExerciseListToPrint : id,
        data,
        categoryId,
        category,
      );
    }

    if (response) {
      if (actionType === "download") {
        downloadFileFromURL({ id: response, fileName });
      } else {
        window.open(response);
      }
    } else {
      alert("Error while fetching the file.");
    }

    setIsDownloadAPILoading(false);
    setIsViewAPILoading(false);
    setSelectedImageSize("small");
    setIncludeHeaderFooter(false);
    setIncludeInstructions(false);

    if (props.setIsDownloadCasePaper) {
      props.setIsDownloadCasePaper(false);
    }

    props.onHide();
  }

  async function downloadPdfHandler() {
    setIsDownloadAPILoading(true);

    if (props.prescriptionId || props.prescriptionId === 0) {
      if (props.prescriptionId === 0 && !props?.isDownloadCasePaper) {
        downloadExercisePrescriptionPDFHandler(props.finalExerciseListToPrint);
      } else if (props?.casePaperId && props?.isDownloadCasePaper) {
        downloadCasePaperPDFHandler(
          props?.casePaperId,
          props?.categoryId,
          props?.category,
          props?.casePaperName,
        );
      } else if (props?.isDownloadCombinedCasePaperLoading) {
        downloadCombinedCasePaperPDFHandler(
          props?.selectedCasePapers,
          props?.category,
          props?.organizationId,
          props?.clientId,
        );
      } else {
        await handleDocumentAction({
          actionType: "download",
          apiFunction: downloadPrescriptionPDFByPrescriptionID,
          id: props.prescriptionId,
          fileName: `${props?.name}.pdf`,
        });
      }
    } else if (invoice) {
      downloadInvoicePdf(invoice);
    } else if (props?.clientConsentAcceptanceForm) {
      downloadClientConsentAcceptanceFormPdf();
    } else if (props?.consentFormId) {
      downloadInitialConsentFormPdf();
    } else if (props?.certificateTemplateId) {
      downloadCertificateTemplatePdf();
    } else if (props?.clientCerificate) {
      downloadClientCertificatePdf();
    } else if (props?.refundToDownload) {
      downloadRefundReceiptPdf(props?.refundToDownload);
    } else {
      if (payment) {
        downloadPaymentReceiptPdf(payment);
      }
    }
  }

  async function viewDocumentById() {
    setIsViewAPILoading(true);

    if (props.prescriptionId || props.prescriptionId === 0) {
      if (props.prescriptionId === 0 && !props?.isDownloadCasePaper) {
        viewExercisePrescriptionPDFHandler(props.finalExerciseListToPrint);
      } else if (props?.casePaperId && props?.isDownloadCasePaper) {
        viewCasePaperByCasePaperIdHandler(
          props?.casePaperId,
          props?.categoryId,
          props?.category,
          props?.clientId,
        );
      } else if (props?.isDownloadCombinedCasePaperLoading) {
        viewCombinedCasePaperPDFHandler(
          props?.selectedCasePapers,
          props?.category,
          props?.organizationId,
          props?.clientId,
        );
      } else {
        await handleDocumentAction({
          actionType: "view",
          apiFunction: viewPrescriptionPDFByPrescriptionID,
          id: props.prescriptionId,
        });
      }
    } else if (invoice) {
      viewInvoicePDF(invoice);
    } else if (props?.clientConsentAcceptanceForm) {
      viewClientConsentAcceptanceFormPdf();
    } else if (props?.consentFormId) {
      viewInitialConsentFormPdf();
    } else if (props?.certificateTemplateId) {
      viewCertificateTemplatePdf();
    } else if (props?.clientCerificate) {
      viewClientCertificatePdf();
    } else if (props?.refundToDownload) {
      viewRefundReceiptPDF(props?.refundToDownload);
    } else {
      viewPaymentReceiptPDF(payment);
    }
  }

  const downloadCasePaperPDFHandler = async (
    casePaperId,
    categoryId,
    category,
    fileName,
  ) => {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadCasePaperPDF,
      id: casePaperId,
      fileName: `${fileName}.pdf`,
      categoryId: categoryId,
      category: category,
    });
  };

  const downloadCombinedCasePaperPDFHandler = async (
    casePaperIds,
    category,
    organizationId,
    clientId,
  ) => {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadCombinedCasePaperPDF,
      id: casePaperIds,
      fileName: "Report.pdf",
      category,
      organizationId,
      clientId,
      isCombined: true,
    });
  };

  const downloadExercisePrescriptionPDFHandler = async (
    finalExerciseListToPrint,
  ) => {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadExercisePrescriptionPDF,
      fileName: `exercisePrescription.pdf`,
      finalExerciseListToPrint: finalExerciseListToPrint,
    });
  };

  const viewExercisePrescriptionPDFHandler = async (
    finalExerciseListToPrint,
  ) => {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewExercisePrescriptionPDF,
      finalExerciseListToPrint: finalExerciseListToPrint,
    });
  };

  async function downloadInvoicePdf(invoiceToDownload) {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadInvoicePDFByInvoiceID,
      id: invoiceToDownload.id,
      fileName: `${invoiceToDownload.clientName}.pdf`,
    });
  }

  async function viewInvoicePDF(invoiceToDownload) {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewInvoicePDFByInvoiceID,
      id: invoiceToDownload.id,
    });
  }

  async function downloadPaymentReceiptPdf(payment) {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadPaymentReceiptPDFByPaymentID,
      id: payment.id,
      fileName: `${payment.clientName}.pdf`,
    });
  }

  async function downloadRefundReceiptPdf(refund) {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadRefundReceiptPDFByRefundID,
      id: refund.id,
      fileName: `${refund.clientName}.pdf`,
    });
  }

  async function viewPaymentReceiptPDF(payment) {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewPaymentReceiptPDFByPaymentID,
      id: payment?.id,
    });
  }

  async function downloadClientConsentAcceptanceFormPdf() {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadClientConsentFormPDFById,
      id: props?.clientConsentAcceptanceForm?.id,
      fileName: `${props?.clientConsentAcceptanceForm?.consentFormName}.pdf`,
    });
  }

  async function downloadClientCertificatePdf() {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadCertificatePDF,
      id: props?.clientCerificate?.id,
      fileName: `${props?.clientCerificate?.certificateName}.pdf`,
    });
  }

  async function downloadCertificateTemplatePdf() {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadCertificateTemplatePDF,
      id: props?.certificateTemplateId,
      fileName: `${props?.certificateTemplateName}.pdf`,
    });
  }

  async function viewClientConsentAcceptanceFormPdf() {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewClientConsentFormPDFByID,
      id: props?.clientConsentAcceptanceForm?.id,
    });
  }

  async function viewCasePaperByCasePaperIdHandler(
    casePaperId,
    categoryId,
    category,
  ) {
    setIsViewAPILoading(true);
    let data = JSON.stringify({
      includeHeaderFooter: includeHeaderFooter,
      includeInstructions: includeInstructions,
      imageSize: selectedImageSize,
    });

    const response = await viewCasePaperByCasePaperId(
      casePaperId,
      data,
      categoryId,
      category,
    );

    if (response) {
      window.open(response);
    } else {
      alert("Error while fetching the file.");
    }
    setIsViewAPILoading(false);
    setSelectedImageSize("small");
    setIncludeHeaderFooter(false);
    setIncludeInstructions(false);
    if (props.setIsDownloadCasePaper) {
      props.setIsDownloadCasePaper(false);
    }
    props.onHide();
  }

  const viewCombinedCasePaperPDFHandler = async (
    casePaperIds,
    category,
    organizationId,
    clientId,
  ) => {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: downloadCombinedCasePaperPDF,
      id: casePaperIds,
      category,
      organizationId,
      clientId,
      isCombined: true,
    });
  };

  async function downloadInitialConsentFormPdf() {
    await handleDocumentAction({
      actionType: "download",
      apiFunction: downloadConsentFormPDF,
      id: props?.consentFormId,
      fileName: props?.consentFromName,
    });
  }

  async function viewInitialConsentFormPdf() {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewConsentFormPDF,
      id: props?.consentFormId,
    });
  }

  async function viewClientCertificatePdf() {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewCertificatePDF,
      id: props?.clientCerificate?.id,
    });
  }

  async function viewCertificateTemplatePdf() {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewCertificateTemplatePDF,
      id: props?.certificateTemplateId,
    });
  }

  async function viewRefundReceiptPDF(refund) {
    await handleDocumentAction({
      actionType: "view",
      apiFunction: viewRefundReceiptPDFByRefundID,
      id: refund?.id,
    });
  }

  return (
    <Modal size="sm" centered show={props.show} dialogClassName="">
      <ModalHeader className="justify-content-center">
        <div>
          <img src={logo} alt="" height="30" className="ms-4 text-center" />
          <h6 className="mb-0 mt-3 text-muted text-center">
            Printing Instructions
          </h6>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="layout-type-wrapper ms-5">
          <label className="mb-0">Include Header Footer:</label>
          <div className="form-check d-flex">
            <input
              id="includeHeaderFooterYes"
              type="radio"
              name="includeHeaderFooter"
              value={includeHeaderFooter}
              onClick={() => setIncludeHeaderFooter(true)}
            />
            <label
              className="form-check-label ms-2"
              htmlFor="includeHeaderFooterYes"
            >
              Yes
            </label>

            <input
              className="ms-4"
              id="includeHeaderFooterNo"
              type="radio"
              name="includeHeaderFooter"
              value={includeHeaderFooter}
              onClick={() => setIncludeHeaderFooter(false)}
              defaultChecked
            />
            <label
              htmlFor="includeHeaderFooterNo"
              className="form-check-label ms-2"
            >
              No
            </label>
          </div>
        </div>

        {props?.exerciseLength > 0 ? (
          <>
            <div className="layout-type-wrapper ms-5">
              <label className="mb-0">Include Instructions:</label>
              <div className="form-check">
                <input
                  id="includeInstructionsYes"
                  type="radio"
                  name="includeInstructions"
                  value={includeHeaderFooter}
                  onClick={() => setIncludeInstructions(true)}
                />
                <label
                  htmlFor="includeInstructionsYes"
                  className="form-check-label ms-2"
                >
                  Yes
                </label>
                <input
                  className="ms-4"
                  id="includeInstructionsNo"
                  type="radio"
                  name="includeInstructions"
                  value={includeHeaderFooter}
                  onClick={() => setIncludeInstructions(false)}
                  defaultChecked
                />
                <label
                  htmlFor="includeInstructionsNo"
                  className="form-check-label ms-2"
                >
                  No
                </label>
              </div>
            </div>

            <div className="layout-type-wrapper ms-5">
              <label className="mb-0">Select Image Size:</label>
              <div className="form-check">
                <input
                  id="imageSizeSmall"
                  type="radio"
                  name="imageSize"
                  value={selectedImageSize}
                  onClick={() => setSelectedImageSize("small")}
                  defaultChecked
                />
                <label htmlFor="imageSizeSmall" className="ms-2">
                  Small
                </label>
              </div>
              <div className="form-check">
                <input
                  id="imageSizeMedium"
                  type="radio"
                  name="imageSize"
                  value={selectedImageSize}
                  onClick={() => setSelectedImageSize("medium")}
                />
                <label htmlFor="imageSizeMedium" className="ms-2">
                  Medium
                </label>
              </div>
              <div className="form-check">
                <input
                  id="imageSizeLarge"
                  type="radio"
                  name="imageSize"
                  value={selectedImageSize}
                  onClick={() => setSelectedImageSize("large")}
                />
                <label htmlFor="imageSizeLarge" className="ms-2">
                  Large
                </label>
              </div>
            </div>
          </>
        ) : null}
      </ModalBody>

      <ModalFooter className="d-flex">
        <Button
          className="small"
          isLoading={isViewAPILoading}
          type="view"
          disabled={isViewAPILoading}
          onClick={viewDocumentById}
          buttonTitle={isViewAPILoading ? "Loading..." : "View"}
        ></Button>
        <Button
          className="success small"
          type="download"
          isLoading={isDownloadAPILoading}
          disabled={isDownloadAPILoading}
          onClick={downloadPdfHandler}
          buttonTitle={isDownloadAPILoading ? "Loading..." : "Download"}
        ></Button>
        <Button
          className="secondary outline small"
          type="reset"
          onClick={() => {
            props.onHide();
            setSelectedImageSize("small");
            setIncludeHeaderFooter(true);
            setIncludeInstructions(true);
            if (props.setIsDownloadCasePaper) {
              props.setIsDownloadCasePaper(false);
            }
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
